import devConfig from './config-dev'
import prodConfig from './config-prod'

const env=window.globalConfig.env;

const CONFIG= env=="dev"?devConfig:prodConfig;



export default CONFIG;


